// components/LoadingOverlay.tsx
import LoadingSpinner from "../../../public/animations/loading-spinner.svg"

const LoadingOverlay = () => (
  <div className="fixed inset-0 z-[9999999] flex items-center justify-center bg-gray-90">
    <div className="relative w-16 h-16">
      <LoadingSpinner className="absolute inset-0 rounded-full animate-spin" />
    </div>
  </div>
)

export default LoadingOverlay
